import { createSelector } from 'reselect'
import { startsWith, cloneDeep } from 'lodash';
import { depositBankObj, segmap } from './model'
import { lowerCaseWhitespace } from '../../../utilities/listUtils';

export const getIsFetchingSegmap = (state, props) => state.segmap.params.isFetching;
export const getIsSegmapFetched = (state, props) => state.segmap.params.segmapFetched;
export const getSegmapList = (state, prop) => state.segmap.byId
export const getIsSearching = (state, props) => state.segmap.params.isSearching;
export const getIsSearchFetched = (state, props) => state.segmap.params.searchFetched;
export const getSearchResults = (state, prop) => state.segmap.searchResults
export const getIsCompanyDetails = (state, prop) => state.segmap.savedCompanyDetails
export const filters = (state, prop) => state.segmap.filterResults;
export const getDeleteStatus = (state, prop) => state.segmap.deleteStatus
export const getDelFetched = (state, prop) => state.segmap.params.isDelFetched
export const getNotification = (state, id) => state.segmap.notifications[id]


export const segmapSelector = (state, prop) => state.segmap.byId;

function modifyForEditCashBankMap(data) {
    const convertedData = [];

    if (data && data !== "" && data !== undefined && data !== null && data !== "[object Object]") {

        let cashBankObject = JSON.parse(data)
        for (const [paymentMode, depositBanks] of Object.entries(cashBankObject)) {
            const depositBankArr = [];
            let depositBank = ""
            let bankLedger = ""
            let ledgerCode = ""

            if (Array.isArray(depositBanks)) {

                for (let i = 1; i < depositBanks.length; i++) {

                    const depositBankObj = depositBanks[i];

                    if (depositBankObj && depositBankObj !== null && depositBankObj !== undefined) {
                        if (typeof (depositBankObj) === "string") {
                            depositBank = "";
                            bankLedger = depositBanks[0];
                            ledgerCode = depositBanks[1];
                        } else {
                            depositBank = Object.keys(depositBankObj)[0];
                            bankLedger = depositBankObj[depositBank][0];
                            ledgerCode = depositBankObj[depositBank][1];
                        }

                    }

                    depositBankArr.push({
                        deposit_bank: depositBank,
                        bank_ledger: bankLedger,
                        ledger_code: ledgerCode
                    });
                }
            }
            // console.log('depositBankArr', depositBankArr)
            convertedData.push({
                payment_mode: paymentMode,
                deposit_bank_arr: depositBankArr
            });
        }

        return convertedData;
    } else {
        return convertedData;
    }
}


export const getSegmap = (state, props) => {
    if (props.match.path === '/segmap/create') {
        let object = segmap()
        object.cash_bank_map = [depositBankObj()]
        return object
    }
    if (props.match.path === '/segmap/edit/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.segmap.byId[id]);
        let cashBankObject = (obj && obj.cash_bank_map !== null && obj.cash_bank_map !== undefined) ? obj.cash_bank_map : ""
        let cashBankMap = modifyForEditCashBankMap(cashBankObject)
        if (cashBankMap && cashBankMap.length === 0) {
            obj.cash_bank_map = [depositBankObj()]
        } else {
            obj.cash_bank_map = cashBankMap
        }
        obj.cid = parseInt(obj.cid, 10)
        obj.segid = parseInt(obj.segid, 10)
        obj.cost_center = lowerCaseWhitespace(obj?.cost_center)
        obj.cost_center_tv = lowerCaseWhitespace(obj?.cost_center_tv)
        obj.cost_cetagory = lowerCaseWhitespace(obj?.cost_cetagory)
        obj.wi_cost_center = lowerCaseWhitespace(obj?.wi_cost_center)
        obj.wi_bndp_cost_center = lowerCaseWhitespace(obj?.wi_bndp_cost_center)
        return obj
    }
    if (props.match.path === '/segmap/clone/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.segmap.byId[id]);
        let cashBankObject = (obj && obj.cash_bank_map !== null && obj.cash_bank_map !== undefined) ? obj.cash_bank_map : ""
        let cashBankMap = modifyForEditCashBankMap(cashBankObject)
        if (cashBankMap && cashBankMap.length === 0) {
            obj.cash_bank_map = [depositBankObj()]
        } else {
            obj.cash_bank_map = cashBankMap
        }
        obj.cid = parseInt(obj.cid, 10)
        obj.segid = parseInt(obj.segid, 10)
        obj.cost_center = lowerCaseWhitespace(obj?.cost_center)
        obj.cost_center_tv = lowerCaseWhitespace(obj?.cost_center_tv)
        obj.cost_cetagory = lowerCaseWhitespace(obj?.cost_cetagory)
        obj.wi_cost_center = lowerCaseWhitespace(obj?.wi_cost_center)
        obj.wi_bndp_cost_center = lowerCaseWhitespace(obj?.wi_bndp_cost_center)
        return obj
    }
}

export const getSegmapParams = (state, props) => {
    const params = {}

    if (startsWith(state.router.location.pathname, '/segmap/create')) {
        params.title = state.segmap.params.createTitle
        params.submitButtonText = state.segmap.params.createSubmitButtonText
    };

    if (startsWith(state.router.location.pathname, '/segmap/edit/')) {
        params.title = state.segmap.params.editTitle
        params.submitButtonText = state.segmap.params.editSubmitButtonText
    };


    if (startsWith(state.router.location.pathname, '/segmap/clone')) {
        params.title = state.segmap.params.cloneTitle
        params.submitButtonText = state.segmap.params.cloneSubmitButtonText
    };

    return params
}

export const selectSegmap = createSelector(
    getSegmapList,
    segmap => {
        const keys = Object.keys(segmap)
        const obj = keys.map((key) => { return { key: key, value: key, text: segmap[key].name } })
        return obj
    })


export const selectSegmapSearched = createSelector(
    getSearchResults,
    segmap => {
        const keys = Object.keys(segmap)
        const obj = keys.map((key) => { return { key: key, value: key, text: segmap[key].name } })
        return obj
    })


export const getFilteredSegmap = createSelector(
    segmapSelector,
    (segmap) => {
        let filteredSegmap = Object.keys(segmap).map(function (key) {
            return segmap[key];
        })
        // filteredSegmap = textFilter(filteredSegmap, filters)
        // filteredSegmap = numberFilter(filteredSegmap, filters)
        return filteredSegmap
    })
